import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pf0002',
    ecrans: [ '00-2',
              '01-2'],
    params: ['id', 'tytcleint']
});
